import { Component, Input, OnInit } from '@angular/core';
import { AuthProvider } from '@providers/auth/auth';
import { BusquedaTesoroProvider } from '@providers/busqueda-tesoro/busqueda-tesoro';
import { App } from 'ionic-angular';
import { BusquedaTesoroNivelDetallePage } from '@pages';
import { LoadingProvider } from '@providers/loading/loading';

@Component({
  selector: 'nivel-card',
  templateUrl: 'nivel-card.html'
})
export class NivelCardComponent implements OnInit {

  @Input() class: string;
  @Input() icono: string;
  @Input() iconoActivo: string;
  @Input() nombreSede: string;
  @Input() UUID: string;
  @Input() esNivelActual: boolean;
  @Input() nivel: any;
  @Input() busquedaTesoro: any;
  @Input() bloquear: boolean;

  equipo: any;
  jugador: any;

  constructor(
    private busquedaTesoroProvider: BusquedaTesoroProvider,
    private authProvider: AuthProvider,
    private app: App,
    private loadingProvider: LoadingProvider,
  ) {   }

  async ngOnInit() {
    this.equipo = await this.authProvider.getEquipo();
    this.jugador = await this.authProvider.getSession();
  }

  async handleSelection() {

    if(this.nivel && !this.nivel.esCompletado && this.esNivelActual) {
      this.obtenPreguntas();
      return;
    }

    if(!this.bloquear && !this.nivel && !this.esNivelActual) {
      this.guardaSeleccion();
      return;
    }

    if(this.nivel && this.nivel.esCompletado ) {
      this.muestraRecompensa();
    }
  }

  async muestraRecompensa() {
    this.app.getRootNavs()[0].setRoot(BusquedaTesoroNivelDetallePage,{
      nombreSede: this.nombreSede,
      objetivo: this.nivel.objetivo,
      busquedaDelTesoro: this.busquedaTesoro,
      avanceID:  this.nivel._id,
      nivel : this.nivel
    });
  }

  private async obtenPreguntas() {
    this.loadingProvider.show(true);
    let response = await this.busquedaTesoroProvider.obtenPreguntasNivel(this.equipo.area._id, this.jugador._id);

    this.app.getRootNavs()[0].setRoot(BusquedaTesoroNivelDetallePage,{
      nombreSede: this.nombreSede,
      preguntas: response.preguntas,
      objetivo: response.objetivo,
      busquedaDelTesoro: this.busquedaTesoro,
      avanceID:  this.nivel._id,
      nivel : this.nivel
    });

    this.loadingProvider.show(false);
  }

  private async guardaSeleccion() {
    this.loadingProvider.show(true);
    let params = {
      busquedaDelTesoro: this.busquedaTesoro,
      jugador: this.jugador._id,
      area: this.equipo.area._id,
      uuid: this.UUID
    };

    let response = await this.busquedaTesoroProvider.seleccionaSede(params);

    this.class = 'active' ;
    this.nivel = response

    this.obtenPreguntas();
  }

}



// WEBPACK FOOTER //
// ./src/components/nivel-card/nivel-card.ts